import React from 'react'


import Learn from '../../../images/Learn.png'
import Roadmap from '../../../images/Cipherem-2.png'

import Fade from "react-reveal/Fade"
import "./about.css"


function AboutArea() {
  return (
	<section className="third-about-area third-about-bg pt-0 pb-90">
            <div className="container custom-container">

            <div className="see-my-info-wrap pt-30 pb-140">
                <div className="row">
                  <div className="col-12">
                    <div className="third-section-title text-center mb-0">
                  <Fade up delay={.4000}>
                      <h2 style={{"fontFamily": "'Oxanium', cursive"}}>Cipherem Ecosystem <span>Overview</span></h2>
                  </Fade>

                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                  <Fade left delay={.4000}>
                    <img src={Roadmap} alt="roadmap" style={{'width' : '100%'}}/>
                  </Fade>

                  </div>
                  
                  
                </div>
              </div>


            <div className="see-my-info-wrap pt-30 pb-80">
                <div className="row">
                  <div className="col-12">
                    <div className="third-section-title text-center mb-35">
                      <Fade up delay={.4000}>
                      <h2 style={{"fontFamily": "'Oxanium', cursive"}}>Engage to <span>Earn</span></h2>
                     </Fade>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                  <Fade down delay={.4000}>
                    <h4>At Cipherem, our primary focus is to create various interactions between communities that results in growth for every individual</h4>
                  </Fade>
                  <Fade down delay={.4000}>
                      <a href="/register" className="btn btn-style-two" style={{'marginTop': '1rem'}}>Sign Up</a>
                      </Fade>
                  </div>
                  
                  
                </div>
              </div>



              <div className="row align-items-center">
                <div className="col-lg-12 order-0 order-lg-2 text-center">
                  <div className="third-about-img text-center position-relative">
                  <Fade right delay={.4000}>
                    {/* <img src={Learn} className="main-img" alt="" /> */}
                      <iframe className='youtube-video' src="https://www.youtube.com/embed/CGOPaxWNStI" title="Cipherem Social Network" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    
                    {/* <img src="" className="shadow" alt="" /> */}
                  </Fade>

                  </div>
                </div>


                {/* <div className="col-lg-6">
                  <div className="third-about-content">
                    <div className="third-title-style">
                    <Fade up delay={.4000}>
                      <h2>Engage to Earn</h2>
                    </Fade>

                      <div className="inner" style={{'paddingLeft': '0px'}}>
                        {/* <h2>skyward sword</h2> */}
                        {/* <h6 className="vertical-title">themebeyond</h6> */}
                      {/* <Fade down delay={.4000}>
                        <p>At Cipherem, our primary focus is to create various interactions between communities that results in growth for every individual</p>
                      </Fade>

                    </div>
                      <Fade down delay={.4000}>
                      <a href="/#" className="btn btn-style-two">Read More </a>
                      </Fade>

                    </div>
                  </div>
                </div> */}


                
              </div>


              
            </div>
          </section>
  )
}

export default AboutArea